module.exports = __webpack_public_path__ + "img/img-722717.png";